<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Vehicle Information
                            </h4>
                        </div>
                        <div class="row">

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Category Name:" label-for="category_id">
                                    <b-form-select id="category_id" placeholder="Select category" :state="validateField(selectedCategoryId, 'number')"
                                        v-model="selectedCategoryId" :options="categories" required
                                        @change="filterBrands"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Name:" label-for="brand_id">
                                    <b-form-select id="brand_id" placeholder="Select brand" :state="validateField(selectedBrandId, 'number')" v-model="selectedBrandId"
                                        :options="filteredBrands" required @change="filterModels"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Model:" label-for="brand_model_id">
                                    <b-form-select id="brand_model_id" placeholder="Select brand model" :state="validateField(brand_model_id, 'number')"
                                        v-model="brand_model_id" :options="filteredModels" required></b-form-select>
                                </b-form-group>
                            </div>


                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Color:" label-for="color">
                                    <b-form-input id="color" placeholder="Enter vehicle color" :state="validateField(color)" v-model="color" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="License Plate: " label-for="license_plate">
                                    <b-form-input id="license_plate" placeholder="Enter license plate" :state="validateField(license_plate)"
                                        v-model="license_plate" required></b-form-input>
                                    <div v-if="errorMessage" class="alert alert-danger" style="color: rgb(220, 53, 69)">
                                        {{ errorMessage.license_plate }}
                                    </div>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Engine Number: " label-for="engine_number">
                                    <b-form-input id="engine_number" placeholder="Enter engine number" :state="validateField(engine_number)"
                                        v-model="engine_number" required></b-form-input>
                                    <div v-if="errorMessage" class="alert alert-danger" style="color: rgb(220, 53, 69)">
                                        {{ errorMessage.engine_number }}
                                    </div>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Registration  Number: "
                                    label-for="registration_number">
                                    <b-form-input id="registration_number" placeholder="Enter registration number" :state="validateField(registration_number)"
                                        v-model="registration_number" required></b-form-input>
                                    <div v-if="errorMessage" class="alert alert-danger" style="color: rgb(220, 53, 69)">
                                        {{ errorMessage.registration_number }}
                                    </div>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Year: " label-for="year">
                                    <b-form-input id="year" placeholder="Enter vehicle year":state="validateField(year, 'number')" v-model="year"
                                        required></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Identification Number: "
                                    label-for="vin">
                                    <b-form-input id="vin" placeholder="Enter vehicle identification number:" :state="validateField(vin)"
                                        v-model="vin" required></b-form-input>
                                    <div v-if="errorMessage" class="alert alert-danger" style="color: rgb(220, 53, 69)">
                                        {{ errorMessage.vin }}
                                    </div>
                                </b-form-group>
                            </div>

                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Unique Identification Code:" label-for="uic">
                                <b-form-input id="uic" placeholder="Enter unique identification code" v-model="uic" required></b-form-input>
                                <div v-if="errorMessage" class="alert alert-danger" style="color: rgb(220, 53, 69)">
                                    {{ errorMessage.uic }}
                                </div>
                                </b-form-group>
                            </div> -->

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Description:" label-for="description">
                                    <textarea class="form-control" id="description" type="text"
                                        placeholder="Enter description"  :class="{'is-invalid': validateField(description) === false, 'is-valid': validateField(description) === true}" v-model="description" required>
                                    </textarea>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Feature:" label-for="features">
                                    <b-form-input id="features" placeholder="Enter feature" :state="validateField(features)" v-model="features" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="User List:" label-for="user_id">
                                    <b-form-select id="user_id" placeholder="Select user id" :state="validateField(user_id, 'number')" v-model="user_id"
                                        :options="users" required>
                                    </b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="SystemNo:" label-for="SystemNo">
                                    <b-form-input id="SystemNo" placeholder="Enter SystemNo" :state="validateField(SystemNo)" v-model="SystemNo"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Company Name:" label-for="insurance_company_name">
                                    <b-form-input id="insurance_company_name" placeholder="Enter Insurance Company Name" :state="validateField(insurance_company_name)" v-model="insurance_company_name"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Policy Number:" label-for="insurance_policy_number">
                                    <b-form-input id="insurance_policy_number" placeholder="Enter Insurance Policy Number" :state="validateField(insurance_policy_number)" v-model="insurance_policy_number"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Expiration Date:" label-for="insurance_expiration_date">
                                    <b-form-input id="insurance_expiration_date" type="date" v-model="insurance_expiration_date" :state="validateField(insurance_expiration_date)"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="WOSS System Installation Date:" label-for="install_date">
                                    <b-form-input id="install_date" type="datetime-local" v-model="install_date" :state="validateField(install_date)"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>


                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Images:" label-for="image">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                        <input type="file" accept="image/*" id="image" multiple
                                            @change="onProfilePictureChange" />
                                    </div>
                                </b-form-group>
                            </div> -->

                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Documents:" label-for="documents">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                        <input type="file" accept="documents/*" id="documents" multiple
                                            @change="onDocumentsChange" />
                                    </div>
                                </b-form-group>
                            </div>
                        </div> -->
                        
                        <!-- Vehicle Images -->
                        <div class="col-md-6 col-12">
                            <b-form-group
                            id="input-group-images"
                            label="Vehicle Images:"
                            label-for="images"
                            description="Recommended size: 300x300px (JPG/PNG)"
                            >
                            <div
                                class="border rounded p-3 text-center"
                                @drop.prevent="onVehicleImageDrop"
                                @dragover.prevent
                                @click="$refs.imageInput.click()"
                                style="cursor: pointer; background-color: #f8f9fa;"
                            >
                                <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                <p class="mb-0">Drag & Drop or Click to Upload</p>
                                <input
                                type="file"
                                accept="image/*"
                                multiple
                                ref="imageInput"
                                class="d-none"
                                @change="onVehicleImagesChange"
                                />
                            </div>

                            <!-- Preview thumbnails -->
                            <div v-if="image.length" class="d-flex flex-wrap mt-2">
                                <div
                                v-for="(img, index) in image"
                                :key="index"
                                class="m-2 position-relative"
                                style="width: 100px; height: 100px;"
                                >
                                <img
                                    :src="getImagePreview(img)"
                                    class="img-thumbnail"
                                    style="width: 100%; height: 100%; object-fit: cover;"
                                />
                                <b-button
                                    size="sm"
                                    variant="danger"
                                    class="position-absolute"
                                    style="top: -8px; right: -8px;"
                                    @click.stop="removeImage(index)"
                                >
                                    ✕
                                </b-button>
                                </div>
                            </div>
                            </b-form-group>
                        </div>

                        <!-- Vehicle Documents -->
                        <div class="col-md-6 col-12">
                            <b-form-group
                            id="input-group-docs"
                            label="Documents:"
                            label-for="documents"
                            description="Upload PDF/DOCX/JPG/PNG (Max 10MB)"
                            >
                            <div
                                class="border rounded p-3 text-center"
                                @drop.prevent="onVehicleDocumentDrop"
                                @dragover.prevent
                                @click="$refs.docsInput.click()"
                                style="cursor: pointer; background-color: #f8f9fa;"
                            >
                                <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                <p class="mb-0">Drag & Drop or Click to Upload</p>
                                <input
                                type="file"
                                accept=".pdf,.doc,.docx,.jpg,.png"
                                multiple
                                ref="docsInput"
                                class="d-none"
                                @change="onVehicleDocumentsChange"
                                />
                            </div>

                            <!-- Preview docs -->
                            <div v-if="documents.length" class="d-flex flex-wrap mt-2">
                                <div
                                v-for="(doc, index) in documents"
                                :key="index"
                                class="m-2 text-center"
                                style="width: 100px;"
                                >
                                    <div v-if="doc.type && doc.type.includes('image')">
                                        <img
                                        :src="getImagePreview(doc)"
                                        class="img-thumbnail"
                                        style="width: 100px; height: 100px; object-fit: cover;"
                                        />
                                    </div>
                                    <div v-else>
                                        <i class="fas fa-file-alt fa-3x text-primary"></i>
                                        <p class="small text-truncate">{{ doc.name }}</p>
                                    </div>
                                    <b-button
                                        size="sm"
                                        variant="danger"
                                        class="mt-1"
                                        @click.stop="removeDocument(index)"
                                    >
                                        Remove
                                    </b-button>
                                </div>
                            </div>
                            </b-form-group>
                        </div>

                        <!-- Vehicle Automark Tattoos -->
                        <div class="col-12">
                            <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;" class="mt-3 mb-3">
                                <h4 style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;">
                                    Vehicle Automark Tattoos
                                </h4>
                            </div>
                            <p class="text-muted small mb-3">
                                Add each tattoo location with a title and photo so inspectors can find and verify them on the vehicle.
                            </p>
                        </div>

                        <div v-for="(tattoo, index) in tattoos" :key="'tattoo-' + index" class="col-12">
                            <b-card class="mb-3 border">
                                <b-row>
                                    <div class="col-md-4 col-12">
                                        <b-form-group label="Location Title:" :label-for="'tattoo-title-' + index">
                                            <b-form-input
                                                :id="'tattoo-title-' + index"
                                                v-model="tattoo.title"
                                                placeholder="e.g. Front Windshield, Driver Door, Rear Window"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <b-form-group
                                            label="Tattoo Photo:"
                                            :label-for="'tattoo-image-' + index"
                                            description="Recommended size: 300x300px (JPG/PNG)"
                                        >
                                            <div
                                                class="border rounded p-3 text-center"
                                                @drop.prevent="onTattooImageDrop($event, index)"
                                                @dragover.prevent
                                                @click="triggerTattooInput(index)"
                                                style="cursor: pointer; background-color: #f8f9fa;"
                                            >
                                                <template v-if="!tattoo.preview">
                                                    <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                                    <p class="mb-0">Drag & Drop or Click to Upload</p>
                                                </template>
                                                <div v-else class="d-flex flex-wrap justify-content-center">
                                                    <div
                                                        class="m-2 position-relative"
                                                        style="width: 100px; height: 100px;"
                                                    >
                                                        <img
                                                            :src="tattoo.preview"
                                                            alt="Tattoo preview"
                                                            class="img-thumbnail"
                                                            style="width: 100%; height: 100%; object-fit: cover;"
                                                        />
                                                        <b-button
                                                            size="sm"
                                                            variant="danger"
                                                            class="position-absolute"
                                                            style="top: -8px; right: -8px;"
                                                            @click.stop="removeTattooPhoto(index)"
                                                        >
                                                            ✕
                                                        </b-button>
                                                    </div>
                                                </div>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    class="d-none"
                                                    ref="tattooInputs"
                                                    @change="onTattooImageChange($event, index)"
                                                />
                                            </div>
                                            <b-form-invalid-feedback v-if="tattooImageError" class="d-block text-danger">
                                                {{ tattooImageError }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-2 col-12 d-flex align-items-center pb-3">
                                        <b-button variant="danger" block @click="removeTattoo(index)">Remove Location</b-button>
                                    </div>
                                </b-row>
                            </b-card>
                        </div>

                        <div class="col-12 mb-3">
                            <b-button variant="outline-primary" @click="addTattoo">+ Add Tattoo Location</b-button>
                        </div>

                         </div>   
                        <!-- Bank Information End -->
                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>

                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
            <code class="hljs html">
              {{ codeText }}
            </code>
          </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
    BFormInvalidFeedback,
} from "bootstrap-vue";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";
import imageCompression from 'browser-image-compression';

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            selectedOption: "",
            inputField1: "",
            inputField2: "",
            inputField3: "",
            showModal: false,
            isLoading: false,
            categories: [],
            brands: [],
            brandModels: [],
            selectedCategoryId: null,
            selectedBrandId: null,
            filteredBrands: [],
            filteredModels: [],

            company_name: "",
            color: "",
            license_plate: "",
            engine_number: "",
            types: "Approved",
            registration_number: "",
            vin: "",
            uic: "",
            year: "",
            status: "safe",
            image: [],
            user_id: 1,
            successMessage: "",
            errorMessage: "",
            documents: [],
            vehicleId: "",
            features: "",
            description: "",
            user_id: "",
            manager_id: "",
            SystemNo: "",
            users: [],
            brand_model_id: "",
            vehicleImageError: "",
            vehicleDocumentError: "",
            install_date: "",
            insurance_company_name: "",
            insurance_policy_number: "",
            insurance_expiration_date: "",
            tattoos: [],
            tattooImageError: "",

        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormSelect,
        BFormInput,
        BToast,
        BSpinner,
        BFormInvalidFeedback,
    },
    mounted() {
        axios.get('CategoryList')
            .then(response => {
                this.categories = response.data.data.map(category => ({
                    value: category.id,
                    text: category.title
                }));
            })
            .catch(error => {
            });

        axios.get('brandList')
            .then(response => {
                this.brands = response.data.data.map(brand => ({
                    value: brand.id,
                    text: brand.name,
                    categoryId: brand.category_id,
                }));
            })
            .catch(error => {
            });
        axios.get('brandModel')
            .then(response => {

                this.brandModels = response.data.data.map(model => ({
                    value: model.id,
                    text: model.title,
                    brandId: model.brand_id,
                }));
            })
            .catch(error => {

            });

        axios.get('approvedAllUsersAndCompanyList')
            .then(response => {
                this.users = response.data.data.map(user => ({
                    value: user.id,
                    text: user.first_name + " " + user.last_name
                }));
            })
            .catch(error => {
            });
    },

    methods: {
        validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
        filterBrands() {
            this.filteredBrands = this.brands.filter(
                brand => brand.categoryId === this.selectedCategoryId
            );
            this.selectedBrandId = null;
            this.filteredModels = [];
        },
        filterModels() {
            this.filteredModels = this.brandModels.filter(
                model => model.brandId === this.selectedBrandId
            );
        },

        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },



        addUser() {
            this.isLoading = true;
            this.errorMessage = "";
            const formData = new FormData();
            formData.append("brand_model_id", this.brand_model_id);
            formData.append("brand_id", this.selectedBrandId);
            formData.append("category_id", this.selectedCategoryId);
            formData.append("company_name", this.company_name);
            formData.append("color", this.color);
            formData.append("SystemNo", this.SystemNo);
            formData.append("license_plate", this.license_plate);
            formData.append("types", this.types);
            formData.append("engine_number", this.engine_number);
            formData.append("registration_number", this.registration_number);
            formData.append("vin", this.vin);
            formData.append("uic", this.uic);
            formData.append("year", this.year);
            formData.append("features", this.features);
            formData.append("description", this.description);
            formData.append("status", this.status);
            formData.append("user_id", this.user_id);
            formData.append("install_date", this.install_date);
            formData.append("insurance_company_name", this.insurance_company_name);
            formData.append("insurance_policy_number", this.insurance_policy_number);
            formData.append("insurance_expiration_date", this.insurance_expiration_date);
            this.managerId = localStorage.getItem("userId");
            this.type = localStorage.getItem("type");
            if (this.type === "manager") {
            formData.append("manager_id", this.managerId);
            formData.append("my_self", this.type);
             }
            // Append each image to FormData
            if (this.image && this.image.length > 0) {
                this.image.forEach((file, index) => {
                    formData.append(`image[${index}]`, file);
                });
            }

            if (this.documents && this.documents.length > 0) {
                this.documents.forEach((file, index) => {
                    formData.append(`documents[${index}]`, file);
                });
            }
            this.tattoos.forEach((tattoo, index) => {
                if (tattoo.title && tattoo.file) {
                    formData.append(`tattoos[${index}][title]`, tattoo.title);
                    formData.append(`tattoos[${index}][image]`, tattoo.file);
                }
            });
            const endpoint = this.type === "manager" ? "vehicleStoreManager" : "vehicleStore";
            axios.post(endpoint, formData)
                .then((response) => {
                    if (response.data.success) {
                        this.$bvToast.toast("Vehicle added successfully!", {
                            title: "Success",
                            variant: "primary",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-right",
                            autoHideDelay: 5000,
                        });

                        this.isLoading = false;
                       if (this.type === "manager") {
                       this.$router.push({ name: 'ListManagerVehicle' });
                        }else {
                        this.$router.push({ name: 'ListVehicle' });
                        }
                    } else {
                        this.errorMessage = response.data.message || "An error occurred.";
                        // this.errorMessage = response.data.message || "{}";
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.message;
                    this.isLoading = false;
                });
        },
        // onProfilePictureChange(event) {
        // const files = event.target.files;

        // if (files && files.length > 0) {
        //     if (files.length > 3) {
        //     // Show an error message if more than 3 images are selected
        //     this.$bvToast.toast("You can only upload up to 3 images.", {
        //         title: "Error",
        //         variant: "danger",
        //         solid: true,
        //         appendToast: true,
        //         toaster: "b-toaster-top-right",
        //         autoHideDelay: 5000,
        //         variant: "primary",
        //     });

        //     // Optionally, trim the selection to the first 3 images
        //     this.image = Array.from(files).slice(0, 3);
        //     } else {
        //     // Store the selected images if 3 or fewer are selected
        //     this.image = Array.from(files);
        //     }
        // }
        // },
        async onProfilePictureChange(event) {
            const files = event.target.files;

            if (files && files.length > 0) {
                // Validate number of files
                if (files.length > 10) {
                    this.$bvToast.toast("You can only upload up to 10 images.", {
                        title: "Error",
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });

                    // Trim selection to first 10 images
                    files = Array.from(files).slice(0, 10);
                }

                try {
                    this.isLoading = true; // Show loading state if needed

                    // Compression options
                    const options = {
                        maxSizeMB: 1,
                        maxWidthOrHeight: 1024,
                        useWebWorker: true
                    };

                    // Compress all selected images
                    const compressionPromises = Array.from(files).map(file =>
                        imageCompression(file, options)
                    );

                    // Wait for all compressions to complete
                    const compressedFiles = await Promise.all(compressionPromises);

                    // Store compressed files
                    this.image = compressedFiles;

                    // Log compression results
                    compressedFiles.forEach(file => {
                        console.log("Compressed image size:", file.size / 1024 / 1024, "MB");
                    });

                } catch (error) {
                    console.error("Image compression error:", error);
                    this.$bvToast.toast("Error compressing images. Using original files.", {
                        title: "Warning",
                        variant: "warning",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });

                    // Fallback to original files if compression fails
                    this.image = Array.from(files);
                } finally {
                    this.isLoading = false;
                }
            }
        },
        onProfilePictureChangeOne(event) {
            const file = event.target.files[0];
            if (file) {
                // Set the selected file to the data property
                this.documents = file;
            }
        },

        onDocumentsChange(event) {
            const files = event.target.files;

            if (files && files.length > 0) {
                if (files.length > 3) {
                    this.$bvToast.toast("You can only upload up to 3 documents.", {
                        title: "Error",
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                        variant: "primary",
                    });

                    this.documents = Array.from(files).slice(0, 3);
                } else {
                    this.documents = Array.from(files);
                }
            }
        },
        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
        async onVehicleImagesChange(event) {
        let files = Array.from(event.target.files);
        if (files.length > 10) files = files.slice(0, 10);

        const options = { maxSizeMB: 1, maxWidthOrHeight: 1024, useWebWorker: true };
        const compressed = await Promise.all(files.map(f => imageCompression(f, options)));
        this.image = compressed;
        },
        onVehicleImageDrop(e) {
        const files = Array.from(e.dataTransfer.files);
        files.forEach(file => this.image.push(file));
        },
        removeImage(index) {
        this.image.splice(index, 1);
        },

        onVehicleDocumentsChange(event) {
        let files = Array.from(event.target.files);
        if (files.length > 5) files = files.slice(0, 5);
        this.documents = files;
        },
        onVehicleDocumentDrop(e) {
        const files = Array.from(e.dataTransfer.files);
        this.documents.push(...files);
        },
        removeDocument(index) {
        this.documents.splice(index, 1);
        },

        getImagePreview(file) {
        if (!file) return "";
        return URL.createObjectURL(file);
        },

        addTattoo() {
            this.tattoos.push({ title: "", file: null, preview: null });
        },
        removeTattoo(index) {
            this.tattoos.splice(index, 1);
        },
        triggerTattooInput(index) {
            const refs = this.$refs.tattooInputs;
            const input = Array.isArray(refs) ? refs[index] : refs;
            if (input) input.click();
        },
        removeTattooPhoto(index) {
            this.tattoos[index].file = null;
            this.tattoos[index].preview = null;
            this.tattooImageError = "";
        },
        async addTattooFile(file, index) {
            if (!file || !file.type.startsWith("image/")) {
                this.tattooImageError = "Only image files allowed.";
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                this.tattooImageError = "Max size per tattoo photo is 5MB.";
                return;
            }
            try {
                const options = { maxSizeMB: 1, maxWidthOrHeight: 1024, useWebWorker: true };
                const compressed = await imageCompression(file, options);
                this.tattoos[index].file = compressed;
                this.tattoos[index].preview = URL.createObjectURL(compressed);
            } catch (error) {
                this.tattoos[index].file = file;
                this.tattoos[index].preview = URL.createObjectURL(file);
            }
            this.tattooImageError = "";
        },
        onTattooImageChange(event, index) {
            const file = event.target.files[0];
            if (file) this.addTattooFile(file, index);
            event.target.value = "";
        },
        onTattooImageDrop(event, index) {
            const file = event.dataTransfer.files[0];
            if (file) this.addTattooFile(file, index);
        },
    },
};
</script>